/** Title and body text of a help card or sheet. */
export const helpTitleClassName =
  'font-manrope text-base font-bold leading-normal text-base-dark';
export const helpTextClassName =
  'mt-2.5 font-nunito text-sm leading-normal tracking-[0.14px] text-neutral-darker';

/** A 24px round button holding a single icon. */
export const iconButtonClassName =
  'flex size-6 cursor-pointer items-center justify-center rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-lightest';

/** The "x" pinned to a help card's top-right corner, level with its title. */
export const cardCloseButtonClassName = `${iconButtonClassName} absolute right-[15px] top-5 hover:bg-neutral-lightest active:bg-neutral-lighter`;

/** The "x" pinned to a help sheet's top-right corner, level with its title. */
export const sheetCloseButtonClassName = `${iconButtonClassName} absolute right-[15px] top-[38px] hover:bg-neutral-lightest active:bg-neutral-lighter`;
